import React from 'react';
import i18next from 'i18next';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Upload } from '@progress/kendo-react-upload';
import styles from '@styles/punch.module.css';
import TextField from "@material-ui/core/TextField";
import { SvgIcon } from "@progress/kendo-react-common";
import { trashIcon, saveIcon, downloadIcon } from "@progress/kendo-svg-icons";
import { encryption } from '@utils/encryption';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { download } from '@utils/download';
import * as StatusCode from '@scripts/StatusCode';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import { addFilesPunch, updateFilesPunch, getFilesPunch, deleteFilePunch } from '@actions/punch';
import AlertAlgo from '@controls/AlertSnack';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { GetLanguage } from '@utils/language';
import PropTypes from 'prop-types';
import moment from "moment";
import { loadLocalization } from '@utils/kendoLocalization';
import { IntlProvider, LocalizationProvider, provideIntlService } from '@progress/kendo-react-intl';

loadLocalization();
moment.locale("fr");

class CustomListItemUI extends React.Component {
    componentDidMount() {
    }

    render() {
        const { files, onRemove } = this.props;

        return (
            <div className={styles.rootFiles}>
                {
                    files.map(file =>
                        <div key={file.name}>
                            <div className={styles.divFilename}>
                                <div className="k-file-name-size-wrapper">
                                    <span className="k-file-name" title="criteres-recherche-1.jpg">{file.name}</span>
                                    <span className="k-file-size">{parseFloat(file.size / 1024).toFixed(2)} KB</span>
                                </div>
                            </div>
                            <div className={styles.rootDivInfoFiles}>
                                <FormControl fullWidth className={styles.rootFilename}>
                                    <TextField
                                        id={"filename_" + file.uid}
                                        label={i18next.t('punch:files.filename')}
                                        defaultValue={file.name.replace(file.extension, '')}
                                    />
                                </FormControl>
                            </div>
                            <div className={styles.deleteFile}>
                                <strong className="k-upload-status">
                                    <button type="button" onClick={() => onRemove(file.uid)} tabIndex="-1" className="k-button k-button-icon k-flat k-upload-action">
                                        <SvgIcon icon={trashIcon} />
                                    </button>
                                </strong>
                            </div>
                        </div>
                    )
                }
            </div>);
    }
}

CustomListItemUI.propTypes = {
    files: PropTypes.array.isRequired,
    onRemove: PropTypes.func
};

class PunchFileUpload extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
            events: [],
            filePreviews: {},
            files_upload: [],
            remove_files_upload: [],
            files_edit: [],
            openConfirmDeleteFile: false,
            deleteFileId: '',
            anchorEl: null,
            language: GetLanguage(),
            punchId: props.punchId,
            showLabel: props.showLabel ?? true,
            isEnabled: props.isEnabled
        }
        this.alert = React.createRef();

        this.intl = provideIntlService(this);
    }

    componentDidMount() {
        if (this.props.punchId) {
            this.loadDocument(this.props.punchId);
        }

        const language = GetLanguage();

        moment.locale(language);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.punchId !== this.props.punchId && this.props.punchId) {
            this.loadDocument(this.props.punchId);
        }
    }

    loadDocument = async (id) => {
        return new Promise((resolve) => {
            getFilesPunch(id).then((response) => {
                const obj = response;

                const files = [];

                obj.files.forEach(item => {
                    files.push(
                        {
                            documentId: item.webDocumentPunchId,
                            filename: item.fileName,
                            extension: item.extension,
                            base64: item.documentBinaryBase64
                        });
                });

                this.setState({ files_edit: files }, async () => {
                    resolve();
                });
            });
        });
    }

    handleDownload = () => {
        if (this.state.downloadFile.type == null) {
            return;
        }

        const file = this.state.downloadFile;

        const linkSource = `data:application/octet-stream;base64,${file.base64}`;

        download(linkSource, `${file.filename}${file.type.toLowerCase()}`, `application/octet-stream`);

        this.handleCloseDownload();
    }

    handleRemoveFile(id) {
        // delete file
        if (id > 0) {
            deleteFilePunch(id).then((response) => {
                if (response.status === StatusCode.STATUS_OK) {
                    // reload document list
                    this.loadDocument(this.state.punchId);
                    this.showMessageSuccess(i18next.t('punch:message.file-delete-success'));
                    this.handleCloseConfirmDeleteFile();
                }
            });
        }
    }

    handleOpenDownload = (event, file) => {
        this.setState({
            anchorEl: event.currentTarget,
            downloadFile: {
                filename: file.filename,
                base64: file.base64,
                type: file.extension
            }
        });
    };

    handleCloseDownload = () => {
        this.setState(
            {
                anchorEl: null,
                downloadFile: null
            }
        );
    };

    handleOpenConfirmDeleteFile = (event, id) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ openConfirmDeleteFile: true, deleteFileId: id });
    }

    handleCloseConfirmDeleteFile = () => {
        this.setState({ openConfirmDeleteFile: false, deleteFileId: 0 });
    }

    onAdd = (event) => {
        const afterStateChange = () => {
            event.affectedFiles
                .filter(file => !file.validationErrors)
                .forEach(file => {
                    const reader = new FileReader();
                    reader.onloadend = (ev) => {
                        this.setState({
                            filePreviews: {
                                ...this.state.filePreviews,
                                [file.uid]: ev.target.result
                            },
                            files_upload: [
                                ...this.state.files_upload,
                                {
                                    uid: file.uid,
                                    base64: ev.target.result.split('base64,')[1],
                                    documentType: file.extension
                                }]
                        });
                    };

                    reader.readAsDataURL(file.getRawFile());
                });
        };

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File selected: ${event.affectedFiles[0].name}`
            ]
        }, afterStateChange);
    }

    onRemove = (event) => {
        const filePreviews = {
            ...this.state.filePreviews
        };

        event.affectedFiles.forEach(file => {
            delete filePreviews[file.uid];
        });

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File removed: ${event.affectedFiles[0].name}`
            ],
            filePreviews: filePreviews
        });
    }

    onProgress = (event) => {
        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `On Progress: ${event.affectedFiles[0].progress} %`
            ]
        });
    }

    onStatusChange = (event) => {
        const fileStatuses = [
            'UploadFailed',
            'Initial',
            'Selected',
            'Uploading',
            'Uploaded',
            'RemoveFailed',
            'Removing'
        ];

        const file = event.affectedFiles[0];

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File '${file.name}' status changed to: ${fileStatuses[file.status]}`
            ]
        });
    }

    handleSaveFileClick = () => {
        const id = this.state.punchId;

        if (id > 0 && this.state.files_upload.length > 0) {
            const idEncrypt = encryption(id);

            const files = [];

            const listFiles = this.state.files_upload.filter(item => document.querySelector(`#filename_${item.uid}`) != null);

            listFiles.forEach(item => {
                const obj = {
                    fileName: document.querySelector(`#filename_${item.uid}`).value,
                    documentBinaryBase64: item.base64,
                    extension: item.documentType
                }

                files.push(obj);
            });

            addFilesPunch({ punchIdEncrypt: idEncrypt, files }).then((result) => {
                if (result.status === StatusCode.STATUS_OK) {

                    this.setState({
                        files: [],
                        filePreviews: {},
                        files_upload: []
                    });

                    this.loadDocument(this.state.punchId);

                    this.showMessageSuccess(i18next.t('punch:message.file-save-success'));
                }
            })
        }
        else {
            this.showMessageError(i18next.t('punch:message.no-file-error'));
        }
    }

    showMessageError = (msg) => {
        this.alert.current.showMessageError(msg);
    }

    showMessageSuccess = (msg) => {
        this.alert.current.showMessageSuccess(msg);
    }

    handleChangeFilename = (index, value) => {
        const files_edit = [...this.state.files_edit];
        files_edit[index] = { ...files_edit[index], filename: value };
        this.setState({ files_edit });
    }

    handleSaveFilename = (index) => {
        const item = this.state.files_edit[index];

        if (!item.filename || !item.filename.trim()) {
            this.showMessageError(i18next.t('punch:message.no-file-error'));
            return;
        }

        updateFilesPunch([{ webDocumentPunchIdCrypt: encryption(item.documentId), fileName: item.filename }]).then((response) => {
            if (response.status === StatusCode.STATUS_OK) {
                this.showMessageSuccess(i18next.t('punch:message.file-save-success'));
            } else {
                this.showMessageError(i18next.t('error:generic-error'));
            }
        });
    }

    render() {
        return (
            <>
                <LocalizationProvider language={this.state.language}>
                    <IntlProvider locale={this.state.language}>
                        <FormControl fullWidth>
                            {this.state.showLabel &&
                                <FormLabel className={`${styles.filesLabel}`}>{i18next.t('punch:form.files')}</FormLabel>
                            }

                            <Upload
                                listItemUI={CustomListItemUI}
                                batch={false}
                                multiple={true}
                                files={this.state.files}
                                withCredentials={false}
                                autoUpload={false}
                                showActionButtons={false}
                                onAdd={this.onAdd}
                                onRemove={this.onRemove}
                                onProgress={this.onProgress}
                                onStatusChange={this.onStatusChange}
                                restrictions={{
                                    maxFileSize: 20000000
                                }}
                            />

                            <FormControl>
                                <div className={styles.listFile} data-id="listFile">
                                    <List>
                                        {this.state.files_edit.map((obj, index) =>
                                            <React.Fragment key={index}>
                                                <ListItem key={index} button data-filename={obj.filename} data-base64={obj.base64} onClick={(event) => this.handleOpenDownload(event, obj)} data-type={obj.extension}>
                                                    <ListItemText primary={
                                                        <>
                                                            <div className={styles.divFilenameUpload}>{i18next.t('punch:files.filename') + i18next.t('common:labelSeparator')}</div>
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    id={`fileName_${index}`}
                                                                    label={''}
                                                                    multiline
                                                                    minRows={4}
                                                                    className={styles.TextFieldFileName}
                                                                    onChange={(event) => this.handleChangeFilename(index, event.target.value)}
                                                                    value={obj.filename}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    } secondary={
                                                        <React.Fragment>
                                                            {this.state.isEnabled && <>
                                                                <strong className={styles.deleteFileList}>
                                                                    <button type="button" tabIndex="-1" onClick={(event) => this.handleOpenConfirmDeleteFile(event, obj.documentId)} className="k-button k-button-icon k-flat k-upload-action">
                                                                        <SvgIcon icon={trashIcon} />
                                                                    </button>
                                                                </strong>
                                                                <strong className={styles.saveFileList}>
                                                                    <button type="button" tabIndex="-1" onClick={() => this.handleSaveFilename(index)} className="k-button k-button-icon k-flat k-upload-action">
                                                                        <SvgIcon icon={saveIcon} />
                                                                    </button>
                                                                </strong>
                                                            </>}
                                                        </React.Fragment>
                                                    } />
                                                </ListItem>
                                                <Divider />
                                            </React.Fragment>
                                        )}
                                    </List>
                                </div>
                            </FormControl>


                            {this.state.files.length > 0 &&
                                <Button
                                    className={styles.buttonFile}
                                    color="primary"
                                    onClick={this.handleSaveFileClick}
                                >
                                    {i18next.t('punch:button.save-file')}
                                </Button>
                            }
                        </FormControl>
                    </IntlProvider>
                </LocalizationProvider>

                <Dialog
                    open={this.state.openConfirmDeleteFile}
                    onClose={this.handleCloseConfirmDeletefile}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">
                        {i18next.t('punch:form.warning')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {i18next.t('punch:message.confirmDeleteFile')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseConfirmDeleteFile} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('punch:form.no')}
                        </Button>
                        <Button autoFocus onClick={() => this.handleRemoveFile(this.state.deleteFileId)} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('punch:form.yes')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseDownload}
                >
                    <MenuItem onClick={this.handleDownload}>{i18next.t('punch:form.download')}</MenuItem>
                </Menu>
                <AlertAlgo ref={this.alert} />
            </>
        )
    }
}

PunchFileUpload.propTypes = {
    showLabel: PropTypes.bool,
    punchId: PropTypes.number.isRequired,
    isEnabled: PropTypes.bool,
};

export default withNamespaces(['punch', 'common'], { wait: true })(PunchFileUpload);